import dialogs from '../helpers/registered-dialogs';

const getDialogOptions = (modalType) => dialogs.get(modalType)?.options || {};

export default getDialogOptions;
